import BaseFactory from 'services/sports/default/base-factory';
import {Factory as PlayerFactory} from './player/factory';
import {Factory as LpFactory} from './lp/factory';
import {Factory as LineupFactory} from './lineup/factory';
import {Factory as SimplexFactory} from './simplex/factory';
import {Factory as UserAdjustmentsValidatorFactory} from './validator/factory';

const classesMap = {
    Lineup: LineupFactory,
    LP: LpFactory,
    Player: PlayerFactory,
    Simplex: SimplexFactory,
    UserAdjustmentsValidator: UserAdjustmentsValidatorFactory,
};

class Factory extends BaseFactory {
    constructor(sportConfig) {
        super();
        this.sportConfig = sportConfig;
    }
    createObj(objectName, params = {}) {
        params = {
            sportConfig: this.sportConfig,
            ...params,
        };

        if (objectName in classesMap) {
            return new classesMap[objectName]().createObj(objectName, params);
        }

        return super.createObj(objectName, params);
    }
}

export {Factory};
